import { useEffect, useState } from "react";
import { ToastMessage } from "hooks/toast";

import SuccessIcon from "assets/icons/feedback/success-bg.svg";
import InfoIcon from "assets/icons/feedback/info-bg.svg";
import WarningIcon from "assets/icons/feedback/warning-bg.svg";
import ErrorIcon from "assets/icons/feedback/error-bg.svg";
import CloseIcon from "assets/icons/feedback/close.svg";

import * as S from "./styles";

interface ToastProps {
  message: ToastMessage;
  onRemove: (id: string) => void;
}

const icons = {
  info: InfoIcon ,
  success: SuccessIcon,
  error: ErrorIcon,
  warning: WarningIcon,
};

const Toast = ({ message, onRemove }: ToastProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onRemove(message.id), 300); // Remove after exit animation
    }, 5000);

    return () => clearTimeout(timer);
  }, [message.id, onRemove]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onRemove(message.id), 300);
  };

  return (
    <S.ToastContainer
      type={message.type || "info"}
      isVisible={isVisible}
      role="alert"
    >
      <S.ToastIcon>
        <img src={icons[message.type || "info"]} alt={message.type} width={35} height={35}/>
      </S.ToastIcon>

      <S.ToastContent>
        <S.ToastTitle>{message.title}</S.ToastTitle>
        {message.description && (
          <S.ToastDescription>{message.description}</S.ToastDescription>
        )}
      </S.ToastContent>

      <S.CloseButton onClick={handleClose}>
        <img src={CloseIcon} alt="Close" width={16} height={20}/>
      </S.CloseButton>
    </S.ToastContainer>
  );
};

export default Toast;
